export const filterSpecialChars = (value, allowSpaces = false) => {
    if (!value) return value;
    const regex = allowSpaces ? /[^a-zA-Z0-9_\s-]/g : /[^a-zA-Z0-9_-]/g;
    return value.replace(regex, '');
};
